$(function(){

	if ($('.lp251101').length) {
		function setItemHeight() {
			$('section.items ul.item_lists li.item_list').each(function(){
				var width = $(this).width();
				$(this).height(width);
			});
		}

		setItemHeight();

		var resizeTimer;
		$(window).on('resize', function(){
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function(){
				setItemHeight();
			}, 200);
		});

		$(window).on('scroll', function(){

			var windowHeight = $(window).height();
			let ScrollY = $(window).scrollTop();

			var MvHeight = $('section.mv').outerHeight();
			if (ScrollY <= MvHeight) {
				$('section.mv .cover').css('--height', (ScrollY * (1/2)) + 'px');
			} else {
				$('section.mv .cover').css('--height', (MvHeight * (1/2)) + 'px');
			}

			var NoveltyHeight = $('section.novelty').outerHeight();
			var NoveltyTop = $('section.novelty').offset().top;

			if (ScrollY <= (NoveltyTop - windowHeight)) {
				$('section.novelty .cover').css('--height', 0 + '%');
			} else
			if ((NoveltyTop - windowHeight) < ScrollY && ScrollY <= (NoveltyTop + NoveltyHeight)) {
				console.log();
				$('section.novelty .cover').css('--height', ((1 - (((NoveltyTop + NoveltyHeight) - ScrollY) / (NoveltyHeight + windowHeight))) * 100) + '%');
			} else
			if ((NoveltyTop + NoveltyHeight) < ScrollY) {
				$('section.novelty .cover').css('--height', 100 + '%');
			}

		});
	}


});